import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidFocusReading } from '../../../../mechanics/rid-focus-reading/rid-focus-reading';

@Component({
  selector: 'app-focus-reading-page',
  imports: [RidFocusReading],
  templateUrl: './focus-reading-page.html',
})
export class FocusReadingPage {
  protected readonly $activatedRoute = inject(ActivatedRoute);
  protected readonly $router = inject(Router);

  protected readonly pace = () => parseInt(this.$activatedRoute.snapshot.queryParams['pace'] ?? '200');
}
